export default __webpack_public_path__ + "static/media/cw.49c7e139.svg";